<script setup lang="ts">
import { ref, watch, onMounted, nextTick } from 'vue';

const props = defineProps<{
  id?: string;
  html?: string;
  sandbox?: string;
  iframeClass?: string;
  style?: string | Record<string, string | number>;
}>();

const iframe = ref<HTMLIFrameElement | null>(null);

watch(
  () => props.html,
  (newVal) => {
    if (iframe.value) {
      iframe.value.srcdoc = newVal || '';
    }
  },
  { immediate: true },
);

onMounted(() => {
  nextTick(() => {
    if (iframe.value) {
      iframe.value.srcdoc = props.html || '';
    }
  });
});
</script>

<template>
  <iframe
    :id="id"
    ref="iframe"
    :sandbox="sandbox ?? 'allow-same-origin'"
    :class="iframeClass"
    :style="style"
  />
</template>

<style scoped>
iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
